exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#teacherHomePage .trialStatusDisplay{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/custom_teacher_home_page.scss
// module id = 1441
// module chunks = 0